/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class PageComponentControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation pageComponentControllerRemoveComponentsFromPage
   */
  static readonly PageComponentControllerRemoveComponentsFromPagePath = '/page-components/remove-components-from-page/{pageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeComponentsFromPage()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeComponentsFromPage$Response(params: {
    pageId: string;
    componentIds?: Array<string>;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PageComponentControllerService.PageComponentControllerRemoveComponentsFromPagePath, 'delete');
    if (params) {
      rb.path('pageId', params.pageId, {});
      rb.query('componentIds', params.componentIds, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeComponentsFromPage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeComponentsFromPage(params: {
    pageId: string;
    componentIds?: Array<string>;
  }): Observable<void> {

    return this.removeComponentsFromPage$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
